import { Component, Input, OnInit } from '@angular/core';
import { DealerPrice } from 'src/app/model/dealer-price.model';

@Component({
  selector: 'app-erp-promotional-text',
  templateUrl: './erp-promotional-text.component.html',
  styleUrls: ['./erp-promotional-text.component.scss'],
  standalone: false,
})
export class ErpPromotionalTextComponent implements OnInit {
  @Input() dealerPriceData: DealerPrice;
  @Input() product: any;
  erpPromotionalTexts: string[] = [];
  constructor() {}

  ngOnInit() {
    this.showERPPromotions();
  }

  showERPPromotions() {
    if (this.product && this.product.promotionMessage) {
      this.erpPromotionalTexts.push(this.product.promotionMessage);
    }
    if (this.dealerPriceData && this.dealerPriceData.promotionMessage) {
      this.erpPromotionalTexts.push(this.dealerPriceData.promotionMessage);
    }
  }
}
